import { React } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { offerone } from "../redux/selectors";

const OfferOne = () => {
  const data = useSelector(offerone("landing"));

  return (
    <section className="offer mt-32">
      <div className="container container-lg">
        <div className="row gy-4">
          {(data.length > 1 ? data.slice(0, 2) : data)?.map((images, index) => (
            <div key={images.id || index} className="col-sm-6">
              <div
                className="offer-card position-relative rounded-16 overflow-hidden flex-align flex-wrap z-1"
                // style={{ height: "300px" }}
              >
                <Link to={images?.directing_link} className="w-100">
                  <img
                    src={images?.image?.files?.original?.url}
                    alt=""
                    className="w-100"
                  />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OfferOne;
